var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43564 1.7832L2.43545 1.78467C26.8146 5.39746 38.7542 18.3846 41.2362 28.9341C41.0317 29.5178 40.7972 30.0126 40.546 30.3958C38.8575 32.9723 34.4403 34.3094 30.6189 33.1884C31.2032 31.2597 31.6083 29.2983 31.7976 27.4149C22.4753 28.2135 11.0413 28.2372 2.38281 25.2038C6.45772 34.5121 12.0825 41.2648 18.4944 47.6726C20.2812 47.4612 21.9912 46.5642 23.5566 45.195C31.8787 48.5805 41.9225 44.9455 45.7 39.2692C50.2822 32.3845 52.9334 8.26143 29.3463 1.7833H23.2347C38.8915 7.14209 42.3489 18.1642 41.943 25.1261C38.315 15.9828 28.4977 6.39023 11.4371 1.7833H2.43584L2.43564 1.7832Z",
    fill: "#1BA397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveReturn);
export default __webpack_public_path__ + "static/media/activeReturn.6db013b65719bacf8377c5d06b6b4aae.svg";
export { ForwardRef as ReactComponent };